import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Loader from "./reuseable/Loader";
import "./App.css";
import pb from "./utils/pocketbase";
import Layout from "./layout/Layout"; // Import your Layout component
import Pos from "./pages/Pos";

function App() {


  const Dashboard = lazy(() => import("./pages/Dashboard"));
  const Accounts = lazy(() => import("./pages/Accounts"));
  const Login = lazy(() => import("./pages/Login"));
  const Transaction = lazy(() => import("./pages/Transaction"));
  const DualTransaction = lazy(() => import("./pages/DualTransaction"));
  const Inventory = lazy(() => import("./pages/Inventory"));
  const TransactionReport = lazy(() => import("./pages/TransactionReport"));
  const SalesReport = lazy(() => import("./pages/SalesReport"));
  const CreditReport = lazy(() => import("./pages/CreditReport"));
  const Ledger = lazy(() => import("./pages/Ledger"));
  const StockReport = lazy(() => import("./pages/StockReport"));
  const FoodOrder = lazy(() => import("./pages/Pos"));
  const Products = lazy(() => import("./pages/Products"));
  const Pharmadashboard = lazy(() => import("./pages/Pharmadashboard"));
  const OrderItems = lazy(() => import("./pages/OrderItems"));
  const Dateset = lazy(() => import("./pages/Dateset"));
  const Orders = lazy(() => import("./pages/Orders"));
  const FoodPos = lazy(() => import("./pages/FoodPos"));
  const Medicine = lazy(() => import("./pages/Medicine"));
  const Posui = lazy(() => import("./pages/pos/Posui"));


  return (
    <>
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          <Routes>
            {/* Login without Layout */}
            <Route path="/" element={<Login />} />

            {/* Routes with Layout */}
            <Route
              path="/dashboard"
              element={
                <Layout>
                  <Dashboard />
                </Layout>
              }
            />
             <Route
              path="/posui"
              element={
                <Layout>
                  <Posui />
                </Layout>
              }
            />
             <Route
              path="/medicine"
              element={
                <Layout>
                  <Medicine />
                </Layout>
              }
            />
             <Route
              path="/foodpos"
              element={
               
                  <FoodPos />
                
              }
            />
              <Route
              path="/orders"
              element={
                <Layout>
                  <Orders />
                </Layout>
              }
            />
              <Route
              path="/dateset"
              element={
                <Layout>
                  <Dateset />
                </Layout>
              }
            />
              <Route
              path="/orders/:orderId"
              element={
                <Layout>
                  <OrderItems />
                </Layout>
              }
            />
            
            <Route
              path="/pharmadashboard"
              element={
                <Layout>
                  <Pharmadashboard />
                </Layout>
              }
            />
             <Route
              path="/products"
              element={
                <Layout>
                  <Products />
                </Layout>
              }
            />
            <Route
              path="/pos"
              element={
                <Layout>
                  <Pos />
                </Layout>
              }
            />
            
             <Route
              path="/transactionreport"
              element={
                <Layout>
                  <TransactionReport />
                </Layout>
              }
            />
              <Route
              path="/stockreport"
              element={
                <Layout>
                  <StockReport />
                </Layout>
              }
            />
            <Route
              path="/creditreport"
              element={
                <Layout>
                  <CreditReport />
                </Layout>
              }
            />
            <Route
              path="/salesreport"
              element={
                <Layout>
                  <SalesReport />
                </Layout>
              }
            />
             <Route
              path="/ledger"
              element={
                <Layout>
                  <Ledger />
                </Layout>
              }
            />
            <Route
              path="/accounts"
              element={
                <Layout>
                  <Accounts />
                </Layout>
              }
            />
            <Route
              path="/transaction"
              element={
                <Layout>
                  <Transaction />
                </Layout>
              }
            />
            <Route
              path="/dualtransaction"
              element={
                <Layout>
                  <DualTransaction />
                </Layout>
              }
            />
            <Route
              path="/inventory"
              element={
                <Layout>
                  <Inventory />
                </Layout>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    </>
  );
}

export default App;
